var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWaveSyncLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.9999 11.8016V2.20156H7.5999V0.601562H1.1999C0.758075 0.601562 0.399902 0.959735 0.399902 1.40156V12.6016C0.399902 13.0434 0.758074 13.4016 1.1999 13.4016H7.5999V11.8016H1.9999Z",
    fill: "#CCCFD1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.73304 10.2047V7.80469H5.19971V6.20469H9.73304V3.80469L13.1997 7.00469L9.73304 10.2047Z",
    fill: "#CCCFD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWaveSyncLogout);
export default __webpack_public_path__ + "static/media/icon-wave-sync-logout.db017817c1786f81f2662282c44614b9.svg";
export { ForwardRef as ReactComponent };